import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const BraintreePaymentService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const deletePaymentAccount = (customerId, accountId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/customers/${customerId}/accounts/${accountId}`, {
      headers,
    });
  };

  const cancelTransaction = (transactionId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/transactions/${transactionId}`, {
      headers,
    });
  };

  const createChargebackForTransaction = (transactionId, version) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/${version}/transactions/${transactionId}/chargeback`,
      {},
      {
        headers,
      }
    );
  };

  const cancelRepresentment = (transactionId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/transactions/${transactionId}/representment`, {
      headers,
    });
  };

  service.deletePaymentAccount = deletePaymentAccount;
  service.cancelTransaction = cancelTransaction;
  service.createChargebackForTransaction = createChargebackForTransaction;
  service.cancelRepresentment = cancelRepresentment;

  return service;
})();

export default BraintreePaymentService;
